import Axios from 'axios';
import { toBase64 } from '../../helpers/utils';

const executePostMultiPart = async (params, files, relativeUrl) => {
  let form = new FormData();

  // Append files to the form data
  if (files) {
    for (let [key, value] of Object.entries(files)) {
      form.append(key, value, value.name);
    }
  }

  // Extract 'params' from the input and convert it to JSON, then append it as a Blob
  const p = params['params'];
  let _params = {};

  if (p) {
    for (let key in p) {
      _params[key] = p[key];
    }
  }

  delete params['params'];
  _params = { ...params, ..._params, };

  const blob = new Blob([toBase64(JSON.stringify(_params))], {
    type: 'application/json'
  });
  form.append('params', blob);

  return Axios.post(relativeUrl, form, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export default {

  getArtifactsJson: async params => {
    return Axios.post('Page/GetArtifactsJson', params);
  },

  getSchema: async params => {
    return Axios.post('page/schema', params);
  },

  getSchemaProcedure: params => Axios.post('page/procedureschema', params),

  executeProcedureAction: (params, files) => executePostMultiPart(params, files, 'page/procedure'),

  executeProcedureActionList: (params, files) => executePostMultiPart(params, files, 'page/procedureList'),

  executeComponentAction: (params, files) => executePostMultiPart(params, files, 'page/component'),

  executeComponentActionList: (params, files) => executePostMultiPart(params, files, 'page/componentlist'),

  executeRequestApiAction: (params, files) => executePostMultiPart(params, files, 'page/requestApi'),

  executeRequestApiActionList: (params, files) => executePostMultiPart(params, files, 'page/requestApilist'),

  lookups: params => Axios.post('lookup/lookup', params),

  initLookups: params => Axios.post('lookup/initlookup', params),

  initLookupsList: params => Axios.post('lookup/initlookuplist', params),

  lookupWindow: params => Axios.post('lookup/lookupwindow', params),

  graphicData: params => Axios.post('page/graphicdata', params),

  cleanCache: params => Axios.post('page/cleancache', params)
};
